
type LoadingOverlayProps = {
    text?: string;
    visible: boolean;
};

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ text = "Loading...", visible }) => {
    if (!visible) return null;

    return (
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-75"
            style={{ zIndex: 2000 }}
        >
            <div className="text-center text-white">
                {/* Bootstrap Spinner */}
                <div className="spinner-border text-light mb-3" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <div>{text}</div>
            </div>
        </div>
    );
};
